module.exports = __webpack_public_path__ + "assets/img/3.1da6f5d5.png";